// Motion videos shown on the homepage teaser and the /motion gallery.
// Drop the video file into /public/videos/motion/, then add an entry below.
// The entry with `featured: true` is shown on the homepage (falls back to the first).
//
// { id, title, src, poster, description, tools, year, featured }
// - src:    path under /public, e.g. "/videos/motion/logo-reveal.mp4"
// - poster: optional still frame shown before the video loads (may be null)
export const motionVideos = [
  {
    id: 1,
    title: "Owó-mi Launch",
    src: "/videos/motion/owomi-launch.mp4",
    poster: null,
    description: "Launch video for Owó-mi, a personal finance app.",
    tools: [],
    year: "2026",
    featured: true,
  },
  {
    id: 2,
    title: "Lull Launch",
    src: "/videos/motion/lull-launch.mp4",
    poster: null,
    description: "Launch video for Lull.",
    tools: [],
    year: "2026",
  },
  {
    id: 3,
    title: "Taiv Promo",
    src: "/videos/motion/taiv-promo.mp4",
    poster: null,
    description: "Promo video for Taiv.",
    tools: [],
    year: "2026",
  },
];
